// extracted by mini-css-extract-plugin
module.exports = {"container":"Day--container--15yFv","day":"Day--day--3XdRA","today":"Day--today--dRADx","icon":"Day--icon--10dct","active":"Day--active--VdP71","triangle":"Day--triangle--3-9-6"};